/*
x-consent-dialog-handler.js

This script's sole purpose is for accordions to work in the consent-settings dialog.
Since the consent content is dynamically generated, a combination of timeouts and
MutationObserver is used.

Does not support going directly to settings using ?consent-settings=true.
Accordions will be left open and expansion styling removed.
If improvement desired, recommend using new CK5 accordions instead, as opposed to JS generation.

The accordions code here is identical to the creation part in x-accordions.js (excluding animation).
*/

export default function xConsentDialogHandler() {

  // Function to create accordions, for use in consent dialog handler
  function createAccordions() {

    // Timeout to allow dynamically added content to appear first
    setTimeout(function () {

      // Accordions code identical to x-accordions.js, excluding animation
      const consentSettings = document.querySelector(".consent-settings");
      const consentAccordions = consentSettings.querySelectorAll('.accordion');

      consentAccordions.forEach(accordion => {
        const details = document.createElement('details');
        const summary = document.createElement('summary');
        const contentWrapper = document.createElement('div');

        details.classList.add('accordion-wrapper');
        contentWrapper.classList.add('accordion-content');

        summary.appendChild(accordion.cloneNode(true));
        details.appendChild(summary);
        details.appendChild(contentWrapper);

        let nextElement = accordion.nextElementSibling;

        // Dependencies when encountering elements that end the accordion or start a new one
        while (nextElement) {
          // Ends when encountering new heading with accordion-class
          if (nextElement.classList.contains('accordion')) {
            break;
          }
          // Ends when encountering any element with accordion-end class
          if (nextElement.classList.contains('accordion-end')) {
            break;
          }
          // Ends when encountering h2 (for both h2-level and h3-level accordion)
          if (nextElement.tagName.toLowerCase() === 'h2') {
            break;
          }
          // If accordion is h3-level, ends when encountering h3
          if (accordion.tagName.toLowerCase() === 'h3' && nextElement.tagName.toLowerCase() === 'h3') {
            break;
          }
          const currentElement = nextElement;
          nextElement = nextElement.nextElementSibling;
          contentWrapper.appendChild(currentElement);
        }
        accordion.parentNode.replaceChild(details, accordion);
      });
    }, 100);
  } // end of createAccordions function



  // Consent dialog handler
  function handleConsentDialog() {
    const consent = document.querySelector(".consent");
    if (!consent) {
      return;
    }

    // If consent dialog appeared, use MutationObserver to detect changes in dynamically generated content
    const consentSettingsObserver = new MutationObserver(function (mutationsList, observer) {
      for (const mutation of mutationsList) {
        if (mutation.type === "childList") {
          mutation.addedNodes.forEach(function (node) {

            // If consent-settings dialog appeared (depends on user click)
            if (node.classList && node.classList.contains("consent-settings")) {

              // Create accordions
              createAccordions();

              // If langunage-switch in consent-settings is clicked, run createAccordions again
              const consentLanguageSwitch = node.querySelector(".consent-settings-lang");
              consentLanguageSwitch.addEventListener("click", function () {
                createAccordions();
              });
            }
          });
        }
      }
    });
    consentSettingsObserver.observe(document, { childList: true, subtree: true });
  }

  // Initialize the script when the page loads. Timeout to ensure detection of consent dialog.
  window.addEventListener("load", function () {
    setTimeout(handleConsentDialog, 500);
  });
}
